<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M14.9512 4.12484C14.4679 4.12484 14.0762 4.51659 14.0762 4.99984C14.0762 5.48309 14.4679 5.87484 14.9512 5.87484V4.12484ZM15.7845 5.87484C16.2678 5.87484 16.6595 5.48309 16.6595 4.99984C16.6595 4.51659 16.2678 4.12484 15.7845 4.12484V5.87484ZM18.2428 4.1665V15.8332H19.9928V4.1665H18.2428ZM4.95117 17.4582C4.05371 17.4582 3.32617 16.7306 3.32617 15.8332H1.57617C1.57617 17.6971 3.08721 19.2082 4.95117 19.2082V17.4582ZM18.2428 15.8332C18.2428 16.7306 17.5153 17.4582 16.6178 17.4582V19.2082C18.4818 19.2082 19.9928 17.6971 19.9928 15.8332H18.2428ZM16.6178 2.5415C17.5153 2.5415 18.2428 3.26904 18.2428 4.1665H19.9928C19.9928 2.30254 18.4818 0.791504 16.6178 0.791504V2.5415ZM4.95117 0.791504C3.08721 0.791504 1.57617 2.30254 1.57617 4.1665H3.32617C3.32617 3.26904 4.05371 2.5415 4.95117 2.5415V0.791504ZM4.95117 2.5415H7.86784V0.791504H4.95117V2.5415ZM7.86784 2.5415H16.6178V0.791504H7.86784V2.5415ZM16.6178 17.4582H13.7012V19.2082H16.6178V17.4582ZM13.7012 17.4582H4.95117V19.2082H13.7012V17.4582ZM3.32617 15.8332V12.9165H1.57617V15.8332H3.32617ZM3.32617 12.9165V4.1665H1.57617V12.9165H3.32617ZM14.527 18.0441L11.6104 9.71078L9.95863 10.2889L12.8753 18.6222L14.527 18.0441ZM11.6104 9.71078L8.69372 1.37745L7.04196 1.95556L9.95863 10.2889L11.6104 9.71078ZM2.74023 13.7424L11.0736 10.8257L10.4954 9.17396L2.16212 12.0906L2.74023 13.7424ZM14.9512 5.87484H15.7845V4.12484H14.9512V5.87484Z"
      :fill="color"
    />
  </svg>
</template>

<script setup>
defineProps({
  color: { type: String, default: 'black' },
})
</script>